import { application } from './application'

// Auto-register every Stimulus controller following the Rails naming convention.
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

Object.entries(controllers).forEach(([path, controller]) => {
  application.register(identifierFromPath(path), controller.default)
})

function identifierFromPath(path) {
  return path
    .replace('./', '')
    .replace('_controller.js', '')
    .replace(/\//g, '--')
    .replace(/_/g, '-')
}
